import {useEffect, useState} from "react"
import useFloating from "../hooks/useFloating"
import useModal from "../hooks/useModal"
import usePermissions from "../hooks/usePermissions"
import useApiDownloads from "../hooks/useApiDownloads"
import Section from "../components/Section"
import SectionHeader from "../components/SectionHeader"
import SectionContent from "../components/SectionContent"
import List from "../components/List"

const formatPickerDate=(date)=>{
    const day=String(date.getDate()).padStart(2,"0")
    const month=String(date.getMonth()+1).padStart(2,"0")
    const year=date.getFullYear()

    return `${day}/${month}/${year}`
}

const addDays=(date,days)=>{
    const next=new Date(date)
    next.setDate(next.getDate()+days)

    return next
}

const toApiDate=(dateValue)=>{
    if(!dateValue){
        return ""
    }

    const parts=dateValue.split("/")
    if(parts.length!==3){
        return ""
    }

    return `${parts[2]}-${parts[1]}-${parts[0]}`
}

export default function Conciliations(){

    const {changeFloating}=useFloating()
    const {restrictSection,checkPermission}=usePermissions()
    const downloadApi=useApiDownloads()
    const defaultLiquidationDateFrom=formatPickerDate(addDays(new Date(),-1))
    const defaultLiquidationDateTo=formatPickerDate(addDays(new Date(),7))
    const [liquidationDateFrom,setLiquidationDateFrom]=useState(()=>defaultLiquidationDateFrom)
    const [liquidationDateTo,setLiquidationDateTo]=useState(()=>defaultLiquidationDateTo)
    const [appliedLiquidationDateFrom,setAppliedLiquidationDateFrom]=useState(()=>defaultLiquidationDateFrom)
    const [appliedLiquidationDateTo,setAppliedLiquidationDateTo]=useState(()=>defaultLiquidationDateTo)

    useEffect(()=>{
        restrictSection("master","")
    },[restrictSection])

    const openFilters=()=>{
        changeFloating("conciliations-filters","","",{
            liquidationDateFrom,
            liquidationDateTo,
            defaultLiquidationDateFrom,
            defaultLiquidationDateTo,
            onApply:(from,to)=>{
                setLiquidationDateFrom(from)
                setLiquidationDateTo(to)
                setAppliedLiquidationDateFrom(from)
                setAppliedLiquidationDateTo(to)
            }
        },"")
    }

    const {changeModal}=useModal()
    const requestParams={
        ...(appliedLiquidationDateFrom ? {liquidationDateFrom:toApiDate(appliedLiquidationDateFrom)} : {}),
        ...(appliedLiquidationDateTo ? {liquidationDateTo:toApiDate(appliedLiquidationDateTo)} : {})
    }

    const downloadConsolidated=()=>{
        const fromPart=requestParams.liquidationDateFrom || "sin-desde"
        const toPart=requestParams.liquidationDateTo || "sin-hasta"
        const fileName=`conciliaciones-consolidado-${fromPart}-a-${toPart}.xlsx`

        downloadApi(
            "conciliation/download-list",
            requestParams,
            fileName,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
    }

    return(
        <Section>
            <SectionHeader
                title="Conciliaciones"
                intro="Pagos conciliados por proveedor."
                back=""
                button={null}
                tabs={[
                    {label:"Transacciones",to:"/c24/actividad"},
                    {label:"Liquidaciones",labelShort:"Liquida...",to:"/c24/actividad/liquidaciones"},
                    {label:"Conciliaciones",labelShort:"Concilia...",to:"/c24/actividad/conciliaciones"},
                    {label:"Cuenta comercial",labelShort:"Cuenta",to:"/c24/actividad/cuenta"}
                ]}
            />
            <SectionContent>
                <List config={{
                    section:"conciliations",
                    endpoint:"conciliation/list",
                    limit:100,
                    counter:{
                        singular:"conciliación",
                        plural:"conciliaciones"
                    },
                    showFilters:true,
                    showSearcher:false,
                    showChanger:false,
                    calendar:null,
                    requestParams,
                    openConciliationsFilters:openFilters,
                    downloadConsolidated,
                    createConciliation:checkPermission({alias:"master_admin",reference:""}) ? ()=>{changeModal("create-conciliation","",0)} : null
                }} />
            </SectionContent>
        </Section>
    )

}
